import React, { useEffect, useState } from "react";
import "./common.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const CommonHealthIssue = ({ selectedTool, setSelectedTool }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);

  const faqs = [
    {
      question: "1. Piles (haemorrhoids)",
      answer: [
        "Piles (haemorrhoids) Piles, also known as haemorrhoids, are swollen veins around the anus (back passage) which may itch, ache or feel sore. You can usually feel the lumpiness of the piles around the anus.",
        " Piles may also bleed a little, and they can make going to the toilet uncomfortable or painful. They occur in pregnancy because the veins relax under the influence of pregnancy hormones. Piles usually go shortly after delivery.",

        "If you suffer from pile :",
        [
          " Eat plenty of food that is high in fibre, like wholemeal bread, fruit and vegetables, and you should drink plenty of water. This will prevent constipation, which can make piles worse",
          "Take regular exercise to improve your circulation.",
          "Sleep with the foot of the bed slightly raised.",
          "vomiting",
          "Ask your doctor, midwife or pharmacist if they can suggest a suitable ointment.",
        ],
      ],
    },
    {
      question: "2. High blood pressure and pre-eclampsia?",
      answer: [
        "During pregnancy your blood pressure will be checked at every antenatal appointment. This is because a rise in blood pressure can be the first sign of pre-eclampsia, often called pregnancy-induced hypertension (PIH) or pre-eclamptic toxaemia (PET).",
        "   Some women experience:",
        [
          "bad headaches",
          "problems with vision, such as blurred vision or lights flashing before the eyes",
          "pain just below the ribs",
          "vomiting",
          "sudden swelling of the face, hands and feet",
        ],
        " Pre-eclampsia usually happens towards the end of pregnancy, but problems can occur earlier. It can also happen after the birth. If the condition worsens, treatment ranges from rest at home or in hospital, to prescribing drugs that lower the high blood pressure. Occasionally, early delivery of the baby may be necessary.",
      ],
    },
    {
      question: "3.  Vaginal discharge",
      answer: [
        "Almost all women have more vaginal discharge in pregnancy. It should be clear and white and it should not smell unpleasant. If the discharge is coloured or smells strange, or if you feel itchy or sore, you may have a vaginal infection. Tell your doctor or midwife. The most common infection is thrush, which your doctor can treat easily. You can help prevent thrush by wearing loose cotton underwear. If vaginal discharge of any colour increases a lot in later pregnancy, tell your doctor or midwife.",
      ],
    },
    {
      question: "4. Deep vein thrombosis (DVT)",
      answer: [
        "Deep vein thrombosis (DVT) is a serious condition where blood clots develop, often in the deep veins of the legs (occasionally it can develop in the pelvis). Pregnant women are 10 times more likely to develop thrombosis than non-pregnant women of the same age.",
        "If you notice one or more of the following symptoms in your leg :",
        [
          "swelling,",
          "pain,",
          "warm skin,",
          "tenderness, and",
          "redness, particularly at the back of the leg below the knee.",
        ],
        "Although medical treatment for DVT is essential, there are things you can do to help yourself, including:",
        [
          "Wear a prescribed compression stocking to help the circulation in your leg.Travel.",
          "drink plenty of water",
          "perform simple leg exercises, such as regularly flexing your ankles. Most airlines provide information on suitable exercises to do during your flight.",
        ],
      ],
    },

    {
      question: "5. Headaches",
      answer: [
        "Some pregnant women find they get a lot of headaches. A brisk walk may be all you need, as well as a little more regular rest and relaxation. Although it is wise to avoid drugs in pregnancy, paracetamol, taken according to the dosage instructions, is generally considered safe.",
        "If you often have bad headaches, tell your maternity team so that they can advise you. Severe headaches may be a sign of high blood pressure and you should seek urgent advice.",
      ],
    },
    {
      question: "6. Varicose veins",
      answer: [
        "Varicose veins are veins that have become swollen. The veins in the legs are most commonly affected. You can also get varicose veins in the vulva (vaginal opening).",
        "   They usually get better after delivery.",
        " You should :",
        [
          "Try to avoid standing for long periods of time.",
          "Try not to sit with your legs crossed.",
          "Try not to put on too much weight as this increases the pressure.",
          "Sit with your legs up as often as you can to ease the discomfort.",
          "Try support tights, which may also help to support the muscles of your legs. You can buy them at most pharmacies.",
          "Try sleeping with your legs higher than the rest of your body. Use pillows under your ankles or raise the foot of your bed.",
          "Do foot exercises and other antenatal exercises, such as walking, cycling and swimming, which will all help your circulation.",
        ],
      ],
    },
    {
      question: "7.Severe itching and obstetric cholestasis",
      answer: [
        "Severe itching when you're pregnant can be a sign of an uncommon condition called obstetric cholestasis. This is a potentially dangerous liver disorder that seems to run in families, although it can occur even if there's no family history.",
        " The symptoms are severe generalised itching without a rash, particularly in the last four months of pregnancy. Obstetric cholestasis can lead to premature birth, stillbirth or serious health problems for your baby. It can also increase the risk of you haemorrhaging (bleeding very heavily) after the birth.",
        " When to get help",
        "You should see your doctor if :",
        [
          "the itching becomes severe, particularly on your hands and feet,",
          "you develop jaundice (yellowing of the whites of the eyes and skin), or",
          " you get itching and a severe rash.",
        ],
      ],
    },
    {
      question: "8. Cramp",
      answer: [
        "Cramp is a sudden, sharp pain, usually in your calf muscles or feet. It is most common at night, but nobody really knows what causes it.",
        "  It usually helps if you pull your toes hard up towards your ankle or rub the muscle hard. Regular, gentle exercise in pregnancy, particularly ankle and leg ",
        "movements, will improve your circulation and may help to prevent cramp occurring.",
      ],
    },
    {
      question: "9. Skin and hair changes",
      answer: [
        "Hormonal changes taking place in pregnancy will make your nipples and the area around them go darker. Your skin colour may also darken a little, either in patches or all over. Birthmarks, moles and freckles may also darken. Some women develop a dark line down the middle of their stomachs. These changes will gradually fade after the baby is born, although your nipples may remain a little darker.",
        "    If you sunbathe while you are pregnant, you may find you burn more easily. Protect your skin with a good, high-factor sunscreen. Don't stay in the sun for very long.",
        " Hair growth is also likely to increase in pregnancy. Your hair may also be greasier. After the baby is born, it may seem as if you're losing a lot of hair. In fact, you're simply losing the increase that occurred during pregnancy.",
      ],
    },
    {
      question: "10. Sleeplessness",
      answer: [
        "Late in pregnancy it can be very difficult to get a good night's sleep. You're uncomfortable lying down, or just when you're beginning to get comfortable, you have to get up to go to the toilet. Some women have strange dreams or nightmares about the baby and about the birth. Talking about them can help you. Just because you dream something, it doesn't mean it's going to happen. Relaxation and breathing techniques may be helpful.",
        "      If you aren't sleeping well",
        [
          "Try not to let it bother you. Don't worry that it will harm your baby – it won't.",
          "Relaxation techniques may help. Your antenatal care or classes may teach relaxation techniques, or you could borrow a cassette from your library.",
          "A warm, milky drink, a warm bath, some gentle exercise or some restful music before bedtime may help.",
        ],
      ],
    },
    {
      question: "11. Faintness",
      answer: [
        "Pregnant women often feel faint. This happens when not enough blood is getting to the brain. If the oxygen level gets too low, you may faint. It's more common in pregnancy because of hormonal changes taking place in your body. You're most likely to feel faint if you stand still for too long or get up too quickly from a chair or hot bath. It often happens when you are lying on your back.",
        "Here are some tips to help you cope:",
        [
          "Try to get up slowly after sitting or lying down.",
          "If you feel faint when standing still, find a seat quickly and the faintness will pass. If it doesn't, lie down on your side.",
          " If you feel faint while lying on your back, turn on your side. It's better not to lie flat on your back in later pregnancy or during labour.",
        ],
      ],
    },
    {
      question: "12. Passing water often",
      answer: [
        "Needing to pass water often is an early sign of pregnancy. Sometimes it continues right through pregnancy. In later pregnancy it's the result of the baby's head pressing on the bladder. If you find that you need to get up in the night, you could try cutting out drinks in the late evening, but make sure you keep drinking plenty during the day.",
        "  Later in pregnancy, some women find it helps to rock backwards and forwards while they are on the toilet. This lessens the pressure of the womb on the bladder so that you can empty it properly. Then you won't need to pass water again quite so soon.  ",
        "The growing baby will increase pressure on the bladder. If you find this a problem, you can start exercises to tone up your pelvic floor muscles. Ask a midwife or obstetric physiotherapist for advice.",
      ],
    },
    {
      question: "13. Slow-growing babies",
      answer: [
        "Many of the tests in pregnancy check the growth of your baby. If you have previously had a very small baby, or if you smoke heavily, the midwives and doctors will already be monitoring your pregnancy closely. Blood pressure checks may also pick up signs of trouble. If there is concern about your baby's health, further tests may be carried out and more frequent monitoring of your baby may be recommended.",

        " In the last weeks of pregnancy you may also be asked to keep track of your baby's movements. If you notice your baby's movements becoming less frequent, slowing down, or stopping altogether, contact your midwife or doctor immediately. If tests show that your baby is not growing well in the womb, early delivery by induction of labour or caesarean section may be suggested.",
      ],
    },
    {
      question: "14. Incontinence (wetting or soiling yourself)",
      answer: [
        "If you sometimes can't help wetting or soiling yourself, you can get help. Incontinence is a very common problem. It can affect anyone, sometimes during and after pregnancy.",
      ],
    },
    {
      question: "15. Stretch marks",
      answer: [
        "These are pink or purplish lines that usually occur on the tummy or sometimes on the upper thighs or breasts. Some women get them, some don't. It depends on your skin type. Some people's skin is more elastic. You are more likely to get stretch marks if your weight gain is more than average. It's very doubtful whether oils or creams help to prevent stretch marks. After your baby is born, the marks should gradually fade and become less noticeable.",
      ],
    },
    {
      question: "16. Feeling hot in pregnancy",
      answer: [
        "During pregnancy you're likely to feel warmer than normal. This is due to hormonal changes and to an increase in blood supply to the skin. You're also likelyto sweat more. It helps if you :",
        [
          "Wear loose clothing made of natural fibres, as these are more absorbent and breathe more than synthetic fibres.",
          "Keep your room cool. Consider using an electric fan.",
          "Wash frequently to stay fresh.",
        ],
      ],
    },
    {
      question: "17. Backache and pelvic joint pain",
      answer: [
        "During pregnancy, ligaments become softer and stretch to prepare you for labour. This can put a strain on the joints of your lower back and pelvis, which can cause backache. As the baby grows, the hollow in your lower back may increase and this may also cause backache.",
        " To avoid backache:",
        [
          " Avoid heavy lifting.",
          "Bend your knees and keep your back straight when lifting or picking up something from the floor. ",
          "Move your feet when turning round to avoid twisting your spine.",
          "Wear flat shoes as these allow your weight to be evenly distributed.",
          "Work at a surface high enough to prevent you stooping.",
          " Sit with your back straight and well supported.",
          "A firm mattress can help to prevent and relieve backache. If it is too soft, a piece of hardboard underneath the mattress will make it firmer.",
        ],
      ],
    },
    {
      question: "18. Pain in pelvic joints",
      answer: [
        " If during or after your pregnancy you have pain in your pelvic joints when walking, climbing stairs, turning in bed etc, you should ask a member of the maternity team for a referral to a manual physiotherapist, osteopath or chiropractor experienced in treating pelvic joint problems.",
        "    You may have a slight misalignment of your pelvic joints (at either the back or front) that is known as pelvic girdle pain (PGP) or symphysis pubis dysfunction (SPD). This affects a large number of pregnant women (up to one in four) and is usually treatable by gentle mobilisation techniques that are safe in pregnancy.",
      ],
    },
    {
      question: "19 . Vaginal bleeding",
      answer: [
        " Bleeding from the vagina at any time in pregnancy can be a danger signal. In early pregnancy, bleeding may be a sign of an ectopic pregnancy or a miscarriage, although many women who bleed at this time go on to have normal and successful pregnancies. If you have bleeding, contact your maternity team or early pregnancy unit at your local hospital straight away.",
        "Bleeding after about five months may be a sign that the placenta is implanted in the lower part of the uterus (placenta praevia) or that it has started to separate from the uterus (placental abruption). Both of these can be dangerous for you and the baby, so contact your midwife or doctor immediately.",
        "The most common sort of bleeding in late pregnancy is the small amount of blood mixed with mucus, known as a 'show'. This is a sign that the cervix is changing and becoming ready for labour to start. You should always report this to your doctor as soon as it occurs.",
      ],
    },
    {
      question: "20. Nausea and morning sickness",
      answer: [
        "Nausea is very common in the early weeks of pregnancy. Some women are sick and some have a feeling of sickness, without being sick. Some feel sick in the mornings, some at other times, some all day long. The reasons are not fully understood, but hormonal changes in the first three months are probably one cause. Nausea usually disappears around the 12th–14th week.",
        [
          "Get plenty of rest and sleep whenever you can. Feeling tired can make the sickness worse.",
          "Eat small amounts often, rather than several large meals, but don't stop eating.",
          "Distract yourself as much as you can. Often the nausea gets worse the more you think about it.",
          "Avoid the foods and smells that make you feel worse. ",
          "Food containing ginger may be helpful.",
        ],
      ],
    },
    {
      question: "21. Nose bleeds",
      answer: [
        "Nose bleeds are quite common in pregnancy because of hormonal changes. They are usually short but can be quite heavy.",

        " To help stop the bleeding, press the sides of your nose together between your thumb and forefinger, just below the bony part of your nose, for 10 minutes. Repeat for a further 10 minutes if this is unsuccessful. As long as you don't lose a lot of blood, there is nothing to worry about.",
        "  Blow your nose gently and try to avoid explosive sneezes. You may also find that your nose gets more blocked up than usual.",
      ],
    },
    {
      question: "22. Itching",
      answer: [
        "Mild itching is common in pregnancy because of the increased blood supply to the skin. In late pregnancy the skin of the abdomen is stretched and this may also cause itchiness. Wearing loose clothing may help. Itching can, however, be a sign of a more serious problem called obstetric cholestasis",

        "   If itching becomes severe, or you develop jaundice (yellowing of the whites of the eyes and skin), see your doctor. Itching that's associated with a rash may also need treatment if it is severe.",
      ],
    },
    {
      question: "23. Leaking nipples",
      answer: [
        "If your nipples are leaking it is usually colostrum, which is the first milk your breasts make in preparation to feed your baby. This is normal and nothing to worry about. However, see a member of the maternity team if it becomes bloodstained.",
      ],
    },
    {
      question: "24. Swollen ankles, feet and fingers",
      answer: [
        "Ankles, feet and fingers often swell a little in pregnancy because the body holds more water than usual. Towards the end of the day, especially if the weather is hot or if you have been standing a lot, the extra water tends to gather in the lowest parts of the body. You should:",
        [
          " Try to avoid standing for long periods.",
          "Wear comfortable shoes.",
          "Put your feet up as much as you can. Try to rest for an hour a day with your feet higher than your heart.",
          "Try to do the foot exercises below – these will help.",
          "Foot exercises :",
          "Foot exercises can be done sitting or standing. They improve blood circulation, reduce swelling in the ankles and prevent cramp in the calf muscles.",
          "Bend and stretch your foot vigorously up and down 30 times.",
          " Rotate your foot eight times one way and eight times the other way.",
        ],
      ],
    },
    {
      question: "25. Teeth and gums",
      answer: [
        "Bleeding gums are caused by a build-up of plaque (bacteria) on the teeth. During pregnancy, hormonal changes in your body can cause the plaque to make the gums more inflamed. They may become swollen and bleed more easily. To keep your teeth and gums healthy, you should:",
        [
          "Pay special attention to cleaning your teeth. Ask your dentist to show you a good brushing method to remove all the plaque.",
          "Avoid having sugary drinks and foods too often. Try to keep them only to meal times.",
          "Avoid having sugary drinks and foods too often. Try to keep them only to meal times.",
          "Remember that dental treatment is free while you are pregnant and for a year after your baby's birth, so have a check-up now.",
          "Discuss with your dentist whether any new or replacement fillings should be delayed until after your baby is born.",
        ],
      ],
    },
    {
      question: "26.Constipation",
      answer: [
        "You may become constipated very early in pregnancy because of the hormonal changes going on in your body. To help prevent constipation:",

        [
          "Include plenty of fibre in your diet with wholemeal breads, wholegrain cereals, fruit and vegetables, and pulses such as beans and lentils.",
          "Exercise regularly to keep your muscles toned.",
          "Drink plenty of water.",
          "Avoid iron pills if they give you constipation. Ask a member of the maternity team if you can manage without them or change to a different type. If not, you may have to accept having constipation",
        ],
      ],
    },
    {
      question: "27. Anxiety and Depression",
      answer: [
        "Anxiety during pregnancy refers to excessive worry, nervousness, or fear about various aspects of pregnancy, childbirth, or motherhood. It can be a normal response to the physical and emotional changes happening during this time, but it can also become more intense for some women.",
        "Causes :",
        [
          "Hormonal fluctuations during pregnancy.",
          "Lack of support from partners, family, or friends.",
          "Previous trauma or personal loss.",
        ],
        "Preventive measures",
        [
          "Seek Professional Help",
          "Eat balanced diet",
          "Practise relaxation techniques that suits you",
        ],
      ],
    },
    {
      question: "28. Preeclampsia",
      answer: [
        "Preeclampsia is a serious pregnancy complication characterised by high blood pressure and potential damage to organs like the kidneys and liver. It typically occurs after the 20th week of pregnancy and can lead to severe complications for both mother and baby if left untreated. Symptoms include high blood pressure, swelling, headaches, blurred vision, and sudden weight gain.",
        "The exact cause of preeclampsia is unknown, but factors like first pregnancies, multiple pregnancies (twins or more), obesity, and pre-existing health conditions (like hypertension or diabetes) can increase the risk.",
        "If diagnosed, managing preeclampsia may involve monitoring blood pressure, bed rest, medications, and, in severe cases, early delivery. Early detection and medical care are crucial for preventing serious outcomes.",
      ],
    },
    {
      question: "29.Mood Swings",
      answer: [
        "Mood swings during pregnancy are common and are often caused by hormonal changes, physical discomfort, and emotional stress. The rapid increase in hormones like oestrogen and progesterone can cause fluctuations in mood, leading to feelings of irritability, sadness, excitement, or anxiety. These mood swings are typically more noticeable during the first and third trimesters.",
        "In addition to hormonal changes, pregnancy-related factors like fatigue, body changes, and concerns about the future can also contribute to emotional shifts. It's important to recognise that mood swings are a normal part of pregnancy, but if they become overwhelming or severe, it’s helpful to talk to a healthcare provider for support or guidance. Relaxation techniques, staying active, and having a support system can help manage emotional ups and downs.",
      ],
    },
    {
      question: "30. Breast Changes",
      answer: [
        "During pregnancy, breasts undergo several changes due to hormonal shifts. They may become larger and more tender, especially in the first trimester. The areolas darken, and Montgomery's tubercles (small bumps) may appear around the nipples. Increased blood flow makes veins more visible. Some women may experience colostrum leakage, a yellowish fluid that nourishes the baby after birth. These changes prepare the breasts for breastfeeding. While these changes are normal, if there’s unusual pain, lumps, or significant discomfort, it's essential to consult a healthcare provider.",
      ],
    },
    {
      question: "31.Increased Blood Volume",
      answer: [
        "During pregnancy, blood volume increases by 40-50% to support the growing baby and placenta. This extra blood helps deliver oxygen and nutrients to the fetus and removes waste. As a result, blood vessels expand to accommodate the increased flow, which may cause a slight drop in blood pressure, especially in the second trimester. The increased blood volume can also lead to swelling in the feet, ankles, and hands. This process is essential for the health of both the mother and baby, ensuring that the body can meet the demands of pregnancy and fetal development.",
      ],
    },
    {
      question: "32. Increased Sensitivity to Smells and Tastes",
      answer: [
        "During pregnancy, heightened sensitivity to smells and tastes is common, mainly due to hormonal changes like increased oestrogen. This can make certain odours overwhelming, even triggering nausea or food aversions. Pregnant women may find themselves craving specific foods or, conversely, developing strong aversions to others. Strong smells like perfumes, cooking odours, or specific foods may worsen morning sickness. Additionally, taste changes can make foods seem stronger or blander than usual. This sensitivity usually decreases after the first trimester but can persist for some women throughout pregnancy.",
      ],
    },
  ];

  const itemsPerPage = 4;
  const pagesToShow = 4; // Show only 4 pages initially
  const totalPages = Math.ceil(faqs.length / itemsPerPage);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const handlePageChange = (page) => {
    setActiveIndex(null);
    setCurrentPage(page);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      if (currentPage === startPage) {
        setStartPage(startPage - pagesToShow);
      }
      setCurrentPage(currentPage - 1);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      if (currentPage === startPage + pagesToShow - 1) {
        setStartPage(startPage + pagesToShow);
      }
      setCurrentPage(currentPage + 1);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const displayedFaqs = faqs.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  useEffect(() => {
    setSelectedTool("/health-issues ");
  }, []);

  return (
    <div className="healthis-base">
      <Helmet>
        <title>
          Common Health Problems During Pregnancy - Solutions & tips
        </title>
        <meta
          name="description"
          content="Common problems faced during pregnancy, such as morning sickness, with effective solutions and helpful tips for a comfortable pregnancy."
        />
        <meta
          name="keywords"
          content="
Pregnancy problems, swelling during pregnancy, pregnancy solutions"
        />
      </Helmet>
      <div className="healthis-main" style={{ position: "relative" }}>
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link
                  to="/"
                  className="breadcrumb-link"
                  onClick={() => setSelectedTool("")}
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Health Issues</li>
            </ol>
          </nav>
        </div>
        <h1
          style={{ textAlign: "center", textTransform: "initial" }}
          className="common-h1"
        >
          Common Health Issue
        </h1>
        <div className="accordion-container">
          {displayedFaqs.map((faq, index) => (
            <div key={index} className="accordion-item">
              <div
                className={`accordion-header ${
                  index === activeIndex ? "active" : ""
                }`}
                onClick={() => toggleAccordion(index)}
              >
                {faq.question}
                <span
                  className={`faq-icon ${
                    activeIndex === index ? "rotate" : ""
                  }`}
                >
                  ▼
                </span>
              </div>
              <div
                className={`accordion-content ${
                  index === activeIndex ? "open" : ""
                }`}
              >
                {faq.answer.map((content, idx) => {
                  if (Array.isArray(content)) {
                    return (
                      <ul key={idx}>
                        {content.map((item, itemIdx) => (
                          <li key={itemIdx}>{item}</li>
                        ))}
                      </ul>
                    );
                  } else if (typeof content === "string") {
                    return (
                      <p key={idx} className="ans">
                        {content}
                      </p>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="pagination1">
          <button
            id="pre-btna"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Prev
          </button>

          {[...Array(Math.min(pagesToShow, totalPages - startPage + 1))].map(
            (_, index) => {
              const pageNumber = startPage + index;
              return (
                <button
                  key={pageNumber}
                  className={currentPage === pageNumber ? "active" : ""}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </button>
              );
            }
          )}

          <button
            id="nex-button"
            onClick={handleNextPage}
            disabled={startPage + pagesToShow > totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommonHealthIssue;
